import React, { memo, useState, lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from '../../../common/translation/translate';
import { GearIcon } from '../../common/icons/gearIcon';

const SettingsPopup  = lazy(() => import('./settingsPopup'));

export const SettingsButton = memo(({ uppercase=false }) => {
    const [ showSettingsPopup, setShowSettingsPopup ] = useState(false);

    return <>
        <SubNavLinkContainer>
            <SubNavLink uppercase={uppercase} onClick={()=>setShowSettingsPopup(true)}>
                <GearIcon />
                { translate('settings') }
            </SubNavLink>
        </SubNavLinkContainer>
        <Suspense fallback={<div>...loading</div>}>
            { showSettingsPopup && <SettingsPopup open={showSettingsPopup} onClose={()=>setShowSettingsPopup(false)} /> }
        </Suspense>
    </>;
});

SettingsButton.displayName = 'SettingsButton';

SettingsButton.propTypes = {
    uppercase: PropTypes.bool
};

const SubNavLinkContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 30px;
    font-size: 14px;
    font-weight: 400;
`;

const SubNavLink = styled.a`
    display: flex;
    align-items: center;
    text-decoration: none;
    color: #FFFFFF;
    cursor: pointer;
    ${({ uppercase }) => uppercase && 'text-transform: uppercase;'}
`;
